import {
  FC, PropsWithChildren,
} from 'react';

export const combineComponents = (...components: FC<PropsWithChildren>[]): FC<PropsWithChildren> => components.reduce(
  (AccumulatedComponents, CurrentComponent) => function ({ children }: PropsWithChildren) {
    return (
      <AccumulatedComponents>
        <CurrentComponent>{children}</CurrentComponent>
      </AccumulatedComponents>
    );
  },
  ({ children }: PropsWithChildren) => <>{children}</>,
);
